import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { ModalContainerComponent } from "../modal-container/modal-container.component";
import { UnsavedChangesModalService } from "../unsaved-changes-modal-wrapper/service/unsaved-changes-modal.service";

@Component({
  selector: 'app-close-modal',
  templateUrl: './close-modal.component.html',
  styleUrls: ['./close-modal.component.scss'],
  imports: [
    ModalContainerComponent,
  ],
})
export class CloseModalComponent implements OnInit {
  private unsavedChangesModalService = inject(UnsavedChangesModalService);

  @Input() isInnerModal = false;
  @Output() closeModal = new EventEmitter<boolean>();

  modalButtons = {
    dismiss: 'Stay',
    apply: 'Leave',
  };

  ngOnInit(): void {
    this.unsavedChangesModalService.showModalEmitter.subscribe();
  }

  close(confirmation: boolean): void {
    this.closeModal.emit(confirmation);
    this.unsavedChangesModalService.resolveDialog(confirmation);
  }
}
